<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <div class="kt-portlet__head-label">
                    <Dropdown v-model="selectedOrg" :options="organizations"
                              optionLabel="display_name" :placeholder="$t('AppDevices.Organização')"
                              class="auto-center" :dataKey="'id'"
                              :filter="true"
                              style="width: 250px"
                              @input="saveChosenOptionsToLocalStorage">
                        <template #option="slotProps" style="width: 500px">
                            <div v-if="loadingOrgs"> {{ $t('AppDevices.Carregando, aguarde') }}</div>
                            <div style="padding-right: 20px" v-else-if="slotProps.option.name === 'ND'">
                                -
                            </div>
                            <div style="padding-right: 20px" v-else>
                                {{ slotProps.option.display_name }}
                            </div>
                        </template>
                    </Dropdown>
                </div>
            </div>
            <div class="kt-portlet__body no-padding">
                <div class="card data-table-width">
                    <DataTable :value="gridData" :paginator="true" :rows="50" :rowHover="true" :loading="loading" stripedRows  :showGridlines="true"
                                :sortOrder="-1" sortField="last_update_date"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                :rowsPerPageOptions="[10,25,50]"
                                :currentPageReportTemplate="$t('AppDevices.currentPageReportTemplate')"
                                :selection.sync="selected_devices" selectionMode="single" dataKey="mac_address"
                                class="p-datatable-customers"
                                :filters.sync="filters" filterDisplay="row" responsiveLayout="scroll">
                        <template #header>
                            <div style="text-align: right">
                                <Button icon="pi pi-external-link" :label="$t('AppDevices.Exportar')" @click="exportCsv" style="font-size: 13px;" />
                            </div>
                        </template>
                        <template #empty>
                            {{ $t('AppDevices.Sem dados para exibir') }}
                        </template>
                        <template #loading>
                            {{ $t('AppDevices.Carregando dipositivos, por favor aguarde') }}


                        </template>
                        <Column field="last_contact" :header="$t('AppDevices.Horário')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width':'11rem'}"
                                    :showFilterMenu="false" :showClearButton="false"
                                    :sortable="true" filterMatchMode="contains">
                            <template #body="slotProps">
                                {{dateHourFormat(slotProps.data.last_contact)}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="city" :header="$t('AppDevices.Município')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width':'12rem'}"
                                :showFilterMenu="false" :showClearButton="false" :sortable="true" filterMatchMode="contains">
                            <template #body="slotProps">
                                {{slotProps.data.city}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="state" :header="$t('AppDevices.Estado')" headerClass="headerClass" :styles="{'min-width':'5rem'}" :showFilterMenu="false" :showClearButton="false"
                                :sortable="true" filterMatchMode="contains" bodyClass="bodyClass">
                            <template #body="slotProps">
                                {{slotProps.data.state}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="mac_address" :header="$t('AppDevices.Serial')" headerClass="headerClass" :styles="{'min-width':'10rem'}" :showFilterMenu="false" :showClearButton="false"
                                :sortable="true" filterMatchMode="custom" bodyClass="bodyClass"
                                :filterFunction="filterValue">
                            <template #body="slotProps">
                                {{slotProps.data.mac_address}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="model" :header="$t('AppDevices.Versão')" headerClass="headerClass" :styles="{'min-width':'10rem'}" :showFilterMenu="false" :showClearButton="false"
                                :sortable="true" filterMatchMode="contains" bodyClass="bodyClass">
                            <template #body="slotProps">
                                {{slotProps.data.model}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                    <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                                </template>
                        </Column>
                        <Column field="iccid" :header="$t('AppDevices.Assinatura')" headerClass="headerClass" :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true" filterMatchMode="contains" :styles="{'min-width':'12rem'}">
                            <template #body="slotProps">
                                {{slotProps.data.iccid}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="fleet" :header="$t('AppDevices.Frota')" headerClass="headerClass" :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true" filterMatchMode="contains" :styles="{'min-width':'12rem'}">
                            <template #body="slotProps">
                                {{slotProps.data.fleet}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="vin" :header="$t('AppDevices.Chassi')" headerClass="headerClass" :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true" filterMatchMode="contains" :styles="{'min-width':'12rem'}">
                            <template #body="slotProps">
                                {{slotProps.data.vin}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="vehicle_manufacturer" :header="$t('AppDevices.Marca')" headerClass="headerClass" :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true" filterMatchMode="contains" :styles="{'min-width':'12rem'}">
                            <template #body="slotProps">
                                {{slotProps.data.vehicle_manufacturer}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="vehicle_model" :header="$t('AppDevices.Modelo')" headerClass="headerClass" :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass"
                                :sortable="true" filterMatchMode="contains" :styles="{'min-width':'12rem'}">
                            <template #body="slotProps">
                                {{slotProps.data.vehicle_model}}
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width':'5rem'}">
                            <template #body="slotProps">
                                <Button icon="pi pi-arrows-h" class="p-button-secondary p-button-rounded p-button-sm"
                                        :title="$t('AppDevices.Transferir dispositivo')"
                                        @click.stop="openTransferDialog(slotProps.data)"/>
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>

            <Dialog :visible.sync="showTransferDialog" modal :closable="!transferring"
                    :style="{width: '36rem', maxWidth: '95vw'}">
                <template #header>
                    <div style="font-size: larger; font-weight: bold" class="pl-3">
                        {{ $t('AppDevices.Transferir dispositivo') }}
                    </div>
                </template>
                <ProgressSpinner v-if="transferring" style="height: 40px"
                                 class="mt-4 mb-4 d-flex align-items-center justify-content-center"/>
                <div v-else class="d-flex flex-column">
                    <div class="mb-3">
                        <div><b>{{ $t('AppDevices.Serial') }}:</b> {{ deviceToTransfer.mac_address }}</div>
                        <div><b>{{ $t('AppDevices.Chassi') }}:</b> {{ deviceToTransfer.vin || '-' }}</div>
                        <div><b>{{ $t('AppDevices.Organização atual') }}:</b>
                            {{ selectedOrg ? selectedOrg.display_name : '-' }}
                        </div>
                    </div>
                    <label for="transferTargetOrg">{{ $t('AppDevices.Organização de destino') }}</label>
                    <Dropdown id="transferTargetOrg" v-model="targetOrg" :options="transferTargetOrgs"
                              optionLabel="display_name" :dataKey="'id'" :filter="true"
                              :placeholder="$t('AppDevices.Organização')" class="mb-3"
                              appendTo="body" scrollHeight="14rem"/>
                    <div v-if="deviceToTransfer.vin" class="d-flex align-items-center mb-2">
                        <Checkbox id="transferVehicle" v-model="transferVehicle" :binary="true"/>
                        <label for="transferVehicle" class="mb-0 ml-2">
                            {{ $t('AppDevices.Transferir o veículo junto com o dispositivo') }}
                        </label>
                    </div>
                    <small v-if="transferVehicle" class="text-muted">
                        {{ $t('AppDevices.Se a organização de destino já tiver um veículo ativo com este chassi, ele será excluído') }}
                    </small>
                    <small v-else class="text-muted">
                        {{ $t('AppDevices.O veículo continua na organização atual, sem dispositivo vinculado') }}
                    </small>
                </div>
                <template #footer>
                    <Button :disabled="transferring" :label="$t('AppDevices.Cancelar')"
                            class="p-button-secondary" @click="closeTransferDialog"/>
                    <Button :disabled="transferring || !targetOrg" :label="$t('AppDevices.Transferir')"
                            class="p-button-info" @click="transferDevice"/>
                </template>
            </Dialog>
        </div>
    </div>
</template>


<script>
import {router} from '../../../router';
import axios from '../../../axios/axios-auth';
import {mapGetters} from 'vuex';
import maskCpfCnpj from "../../../mixins/StringsMaskMixin";
import dateHourFormat from "../../../mixins/DateMixin";
import maskMacAddress from "../../../mixins/StringsMaskMixin";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import MultiSelect from 'primevue/multiselect';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import ProgressBar from 'primevue/progressbar';
import Button from 'primevue/button'
import Dialog from 'primevue/dialog';
import Checkbox from 'primevue/checkbox';
import ProgressSpinner from 'primevue/progressspinner';
import DevicesService from "../../../services/DevicesService";
import {STATUS} from "../../../constants/status";
import AppButton from "../../common/AppButton";
import filterValue from "../../../mixins/FilterFunctionsDataTables";
import formatData from "../../../mixins/SizesMixin"
import OrganizationsService from "@/services/OrganizationsService";
import orderCustomFieldByNaturalOrder from "@/mixins/ArrayMixin";
import exportJsonToCsv from '@/mixins/JsonToCsvMixin';
import {FilterMatchMode} from 'primevue/api';
import {FilterService} from 'primevue/api';
const DATE_FILTER = 'DATE FILTER';

export default {
    mixins: [maskCpfCnpj, maskMacAddress, status, dateHourFormat, filterValue, formatData, orderCustomFieldByNaturalOrder, exportJsonToCsv],
    mounted() {
        this.devicesService = new DevicesService();
        FilterService.register(DATE_FILTER, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }

            if (value === undefined || value === null) {
                return false;
            }

            return this.dateHourFormat(value).includes(filter);
        });
        this.organizationsService = new OrganizationsService();
        this.getOrganizations();
    },
    data() {
        return {
            status_list: STATUS,
            devicesService: null,
            selected_devices: [],
            loading: false,
            filters: {
                'last_contact': {value: null, matchMode: DATE_FILTER},
                'city': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'state': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'mac_address': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'model': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'iccid': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'fleet': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'vin': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'vehicle_model': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'vehicle_manufacturer': {value: null, matchMode: FilterMatchMode.CONTAINS}
            },
            gridData: [],
            organizations: [],
            organizationsService: null,
            loadingOperators: false,
            loadingOrgs: false,
            selectedOrg: null,
            storedChosenOptions: {},
            showTransferDialog: false,
            transferring: false,
            transferVehicle: false,
            deviceToTransfer: {},
            targetOrg: null
        }
    },
    components: {
        DataTable,
        Column,
        InputText,
        MultiSelect,
        Calendar,
        Dropdown,
        ProgressBar,
        Button,
        AppButton,
        Dialog,
        Checkbox,
        ProgressSpinner
    },
    methods: {
        exportCsv(){
            let csvData = [];

            let tempData = JSON.parse(JSON.stringify(this.gridData));

            tempData.forEach(data => {
                data.last_contact = this.dateHourFormat(data.last_contact);
                csvData.push(data);
            });

            const CSV_FIELDS = ['last_contact', 'city', 'state', 'mac_address', 'model', 'iccid', 'fleet', 'vin', 'vehicle_manufacturer', 'vehicle_model'];
            const CSV_LABELS = [this.$t('AppDevices.Horário'), this.$t('AppDevices.Município'), this.$t('AppDevices.Estado'), this.$t('AppDevices.Serial'), this.$t('AppDevices.Versão'), this.$t('AppDevices.Assinatura'), this.$t('AppDevices.Frota'), this.$t('AppDevices.Chassi'), this.$t('AppDevices.Marca'), this.$t('AppDevices.Modelo')];

            this.exportJsonToCsv(CSV_FIELDS, CSV_LABELS, csvData, "devices");
        },
        formatICCID(val) {
            // retira os quatro primeiros digitos do iccid se estiveram presentes
            // 2 primeiros codigo da industria sempre 89
            // 2 seguintes codigo do pais, 55 no caso do brasil
            if (!val) {
                return "";
            }

            if (val.length <= 16) {
                return val;
            }
            return val.substring(4);
        },
        getOrganizations() {
            let vm = this;
            this.loadingOrgs = true;
            this.organizationsService.getAllV3('DEVICES').then((results) => {
                this.populateOrgsList(results);
                this.loadFilteredOptions();
            })
                .catch((error) => {
                    vm.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppDevices.Operação falhou'),
                        detail: this.$t('AppDevices.Não foi possível buscar organizações'),
                        life: 5000
                    });
                    console.log(error)
                }).finally(() => {
                this.loadingOrgs = false;
            })
        },
        populateOrgsList(orgs) {
            orgs.forEach(data => {
                data.mac_address = this.maskMacAddress(data.mac_address);
                data.iccid = this.formatICCID(data.iccid);
            });
            this.organizations = this.orderCustomFieldByNaturalOrder(orgs, "name");
        },
        getDevices(selectedOrg) {
            let vm = this;
            this.loading = true
            this.devicesService.getDevicesByOrg(selectedOrg.id).then((response) => {
                vm.gridData = response
            }).catch(function (error) {
                if (!error.response || error.response.status !== 403) {
                    this.$toast.add({
                        severity: 'error',
                        summary: this.$t('AppDevices.Não foi possivel completar a operação'),
                        life: 5000
                    });
                    return;
                }
                vm.$toast.add({
                    severity: 'error',
                    summary: this.$t('AppDevices.Você não tem acesso a esta funcionalidade'),
                    life: 5000
                });
            }).finally(() => {
                vm.loading = false;
            })
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.storedChosenOptions['clients'].filter(a => this.organizations.some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        openTransferDialog(device) {
            this.deviceToTransfer = device;
            this.targetOrg = null;
            this.transferVehicle = false;
            this.showTransferDialog = true;
        },
        closeTransferDialog() {
            this.showTransferDialog = false;
            this.deviceToTransfer = {};
            this.targetOrg = null;
            this.transferVehicle = false;
        },
        transferDevice() {
            if (!this.targetOrg) {
                return;
            }

            let vm = this;
            this.transferring = true;
            this.devicesService.transferDevice(this.deviceToTransfer.id, this.targetOrg.id, this.transferVehicle)
                .then(() => {
                    vm.$toast.add({
                        severity: 'success',
                        summary: vm.$t('AppDevices.Dispositivo transferido com sucesso'),
                        life: 5000
                    });
                    vm.closeTransferDialog();
                    vm.getDevices(vm.selectedOrg);
                })
                .catch((error) => {
                    vm.$toast.add({
                        severity: 'error',
                        summary: vm.$t('AppDevices.Operação falhou'),
                        detail: vm.getTransferErrorDetail(error),
                        life: 5000
                    });
                })
                .finally(() => {
                    vm.transferring = false;
                })
        },
        getTransferErrorDetail(error) {
            const status = error.response ? error.response.status : null;

            if (status === 401 || status === 403) {
                return this.$t('AppDevices.É necessário permissão de equipamento de edição na organização atual e na de destino');
            }

            if (status === 409) {
                return this.$t('AppDevices.O dispositivo já pertence a esta organização');
            }

            return this.$t('AppDevices.Não foi possivel completar a operação');
        },
    },
    watch: {
        selectedOrg: function (val) {
            if (!val) {
                return;
            }
            this.getDevices(val)
        }
    },
    computed: {
        transferTargetOrgs() {
            if (!this.selectedOrg) {
                return this.organizations;
            }

            return this.organizations.filter(org => org.id !== this.selectedOrg.id);
        },
        ...mapGetters([
            'getCurrentOrganization',
            'isAuthenticated',
        ])
    },
}
</script>


<style lang="scss">
@import "./src/assets/styles/primevue";


@media (max-width: 1024px){
    .data-table-width{
        width: 100vw;
    }
}

@media (min-width: 1025px){
    .data-table-width{
        max-width: calc(100vw - 140px);
    }
}
</style>
